<template>
  <main>
    <div class="container-fluid">
      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="real-time-content-tab" data-bs-toggle="pill" data-bs-target="#real-time-content"
            type="button" role="tab" aria-controls="real-time-content" aria-selected="true"> 即時 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="sum-content-tab" data-bs-toggle="pill" data-bs-target="#sum-content" 
            type="button" role="tab" aria-controls="sum-content" aria-selected="false">統計 </button>
        </li>
      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
         <real-time></real-time>
         <sum></sum>
      </div>
    </div>
  </main>
</template>

<script>
import realTime from './realTime.vue';
import sum from './sum.vue';



export default {
  components: { realTime, sum},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
